<template>
  <v-container class="my-12">
    <!-- Título de la sección -->
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="sectionTitle"
          label="Ademas"
          disabled
          class="headline text-center"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Contenido de las características -->
    <v-row dense>
      <v-col cols="12" sm="6" md="4" v-for="(item, i) in features" :key="i">
        <v-hover v-slot="{ hover }">
          <v-card :elevation="hover ? 12 : 4" class="rounded-xl transition-swing">
            <v-img
              :src="item.img"
              height="200px"
              class="rounded-t-xl"
              gradient="to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.7)"
            >
              <v-card-title class="white--text text-h6 font-weight-bold">
                {{ item.title }}
              </v-card-title>
            </v-img>

            <v-card-text class="text-body-2 py-4">
              {{ item.text }}
            </v-card-text>

            <v-card-actions>
              <v-btn
                v-if="item.link"
                :href="item.link"
                target="_blank"
                color="primary"
                text
                class="ml-auto"
              >
                <v-icon left>mdi-open-in-new</v-icon>
                Ir ahora
              </v-btn>
              <v-btn v-else color="primary" text class="ml-auto"> Ver más </v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    sectionTitle: "Impulsa tu Futuro Profesional",
    features: [
      {
        title: "Convenios",
        text:
          "Tenemos conveniios con diferentes empresas para la captacion de Talento Laboral",
        img: require("@/assets/referido.jpg"),
      },
      {
        title: "Biblioteca Virtual",
        text: "Accede a miles de libros digitales y recursos académicos gratuitos.",
        img: "https://covers.openlibrary.org/b/id/5546156-L.jpg",
        link: "https://openlibrary.org/",
      },
      {
        title: "Bolsa de Trabajo",
        text: "Encuentra oportunidades laborales como desarrollador de software.",
        img: require("@/assets/bolsa.png"),
        link: "https://pe.indeed.com/jobs?q=Desarrollador+de+software",
      },
    ],
  }),
};
</script>

<style scoped>
.transition-swing {
  transition: all 0.3s ease;
}

.headline {
  font-weight: bold;
  font-size: 32px;
}
</style>
